module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    attrs: {
      "for": "ModelNameEdit"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.name),
      expression: "value.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "ModelNameEdit",
      "placeholder": "Enter model name",
      "required": ""
    },
    domProps: {
      "value": (_vm.value.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "DescriptionEdit"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.description),
      expression: "value.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "DescriptionEdit",
      "placeholder": "Enter model description",
      "required": ""
    },
    domProps: {
      "value": (_vm.value.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "categoryEdit"
    }
  }, [_vm._v("Category")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.category),
      expression: "value.category"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Category",
      "id": "categoryEdit",
      "placeholder": "Enter model category"
    },
    domProps: {
      "value": (_vm.value.category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "category", $event.target.value)
      }
    }
  }), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.logCommands),
      expression: "value.logCommands"
    }],
    attrs: {
      "type": "checkbox",
      "id": "CommandLoggingEnabledEdit"
    },
    domProps: {
      "checked": Array.isArray(_vm.value.logCommands) ? _vm._i(_vm.value.logCommands, null) > -1 : (_vm.value.logCommands)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.value.logCommands,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.value, "logCommands", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.value, "logCommands", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.value, "logCommands", $$c)
        }
      }
    }
  }), _vm._v("Log changes to model\n    ")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7700397a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7700397a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/new-model-editor/new-model-editor.vue.html
// module id = 1116
// module chunks = 0